export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: String,
  },
  methods: {
    onToggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-settings-button/market-settings-button.js